module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "moileParticulars"
  }, [_c('van-nav-bar', {
    attrs: {
      "title": _vm.goods.goodsName,
      "fixed": "",
      "left-text": "返回",
      "left-arrow": ""
    },
    on: {
      "click-left": function($event) {
        return _vm.$router.back(-1)
      }
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.refreshing),
      callback: function($$v) {
        _vm.refreshing = $$v
      },
      expression: "refreshing"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": ""
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(goods) {
    return _c('van-card', {
      key: goods.id,
      attrs: {
        "title": goods.goodsName,
        "desc": _vm.delHtmlTag(goods.goodsDesc),
        "thumb": goods.pictureShowUrl
      },
      on: {
        "click": function($event) {
          return _vm.gotoPlay(goods.id)
        }
      },
      scopedSlots: _vm._u([{
        key: "tags",
        fn: function() {
          return [_c('van-tag', {
            attrs: {
              "plain": "",
              "type": "danger"
            }
          }, [_vm._v(_vm._s(_vm.formatPer(goods.progressPercent)))]), _vm._v(" "), _c('van-tag', {
            attrs: {
              "plain": "",
              "type": "danger"
            }
          }, [_vm._v(_vm._s(goods.testHours) + "课时")])]
        },
        proxy: true
      }], null, true)
    })
  }), 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1585b746"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileClassDetail.vue
// module id = 1134
// module chunks = 41